import React from "react";
import styled from "styled-components";
import { Card, Typography, Tag, Tooltip, Collapse } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import RequirementTag from "./RequirementTag.js";
const { Text } = Typography;
const monsterIcons = require.context("../assets/icons", false, /\.(png)$/);

const MonsterCard = ({ monster }) => {
  return (
    <Card
      title={
        <a
          href={monster.monster_name.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#ffff00",
            fontSize: "20px",
            textDecoration: "underline",
            textUnderlineOffset: "4px",
            fontFamily: "Chakra Petch, sans-serif",
          }}
        >
          {monster.monster_name.name}
        </a>
      }
      style={{ marginBottom: "20px", borderRadius: "8px", cursor: "unset" }}
      hoverable
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <TopSection>
          <LeftTaskSection>
            <Typography>
              <Text strong>Task Length: </Text>
              {monster.task_length}
              {monster.extend_length && (
                <Tooltip
                  placement="right"
                  title={`Extended Length: ${monster.extend_length}`}
                  color="rgba(0, 0, 0, 0.6)"
                >
                  <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                </Tooltip>
              )}
            </Typography>
            <Typography style={{ marginTop: "10px" }}>
              <Text strong>Unlock Requirement: </Text>
              <>
                {monster.unlock_requirement?.map((req, idx) => (
                  <RequirementTag key={idx} requirement={req} />
                ))}
              </>
            </Typography>
            <Typography style={{ marginTop: "10px" }}>
              <Text strong>Locations: </Text>
              {monster.locations &&
                monster.locations.map((location, idx) => (
                  <a
                    key={idx}
                    href={location.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "white" }}
                  >
                    <Tag color="blue">{location.name}</Tag>
                  </a>
                ))}
            </Typography>
            <Typography style={{ marginTop: "10px" }}>
              <Text strong>Attack Styles: </Text>
              {monster.attack_styles &&
                monster.attack_styles.map((style, idx) => (
                  <a
                    key={idx}
                    href={style.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "white" }}
                  >
                    <Tag color="green">{style.name}</Tag>
                  </a>
                ))}
            </Typography>
            {monster.alternatives && monster.alternatives.length > 0 && (
              <Typography style={{ marginTop: "10px" }}>
                <Text strong>Alternatives: </Text>
                {monster.alternatives.map((alt, idx) => (
                  <a
                    key={idx}
                    href={alt.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "white" }}
                  >
                    <Tag color="purple">{alt.name}</Tag>
                  </a>
                ))}
              </Typography>
            )}
            <Typography style={{ marginTop: "10px" }}>
              <Text strong>Task Chance: </Text>
              {(monster.task_chance * 100).toFixed(2)}%
            </Typography>
          </LeftTaskSection>

          <RightTaskSection>
            {monster.monster_img && (
              <img
                src={monsterIcons(`./${monster.monster_img}`)}
                alt={monster.monster_name.name}
                loading="lazy"
                width="100"
                style={{ borderRadius: "8px" }}
              />
            )}
          </RightTaskSection>
        </TopSection>

        <BottomSection>
          {monster.task_notes && monster.task_notes.length > 0 && (
            <div style={{ marginTop: "20px", width: "100%" }}>
              <Collapse
                bordered={false}
                items={[
                  {
                    key: "1",
                    label: "Task Notes",
                    children: (
                      <ul style={{ maxWidth: "300px" }}>
                        {monster.task_notes.map((note, idx) => (
                          <li key={idx}>{note}</li>
                        ))}
                      </ul>
                    ),
                  },
                ]}
              />
            </div>
          )}
        </BottomSection>
      </div>
    </Card>
  );
};

export default MonsterCard;

const TopSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const BottomSection = styled.div``;

const CARD_MAX_WIDTH = "440px";
const LeftTaskSection = styled.div`
  max-width: ${CARD_MAX_WIDTH};
`;

const RightTaskSection = styled.div``;
